import { render, staticRenderFns } from "./BaseCampaignReportLayout.vue?vue&type=template&id=5cdc8d44&scoped=true&"
import script from "./BaseCampaignReportLayout.vue?vue&type=script&lang=js&"
export * from "./BaseCampaignReportLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseCampaignReportLayout.vue?vue&type=style&index=0&id=5cdc8d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdc8d44",
  null
  
)

export default component.exports